import router from '../../router'
import LogService from '../../services/LogService'

const state = () => ({
    loadingLogs: false,
    log: null,
    logs: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_log: false
})
  
const mutations = {
    SET_LOG: (state, payload) => {
        state.log = payload
    },
    SET_LOGS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.logs = payload.itens
        }else{
            state.logs = [...state.logs, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_LOGS: (state, payload) => {
        state.loadingLog = payload
    },
    SET_SHOW_MODAL_LOG: (state, payload) => {
        state.show_modal_new_log = payload
    },
}

const actions = {
    async fetchLog({commit}, id){
        try{
            commit('SET_LOADING_LOGS', true)
            const response = await LogService.getOne(id);
            commit('SET_LOG', response.data)
            commit('SET_LOADING_LOGS', false)
        } catch (error) {
            commit('SET_LOADING_LOGS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchLogs({commit}, params = {}){
        try{
            commit('SET_LOADING_LOGS', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'DESC' }, UserId = '' } = params;
            const response = await LogService.get(keyword, pageNumber, pageSize, order, UserId);
            commit('SET_LOGS', response.data)
            commit('SET_LOADING_LOGS', false)
        } catch (error) {
            commit('SET_LOADING_LOGS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createLog({commit}, data){
        try{
            commit('SET_LOADING_LOGS', true)
            const response = await LogService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_LOG', false)
            commit('SET_LOADING_LOGS', false)
        } catch (error) {
            commit('SET_LOADING_LOGS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeLog({commit}, data){
        try{
            commit('SET_LOADING_LOGS', true)
            const response = await LogService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_LOGS', false)
        } catch (error) {
            commit('SET_LOADING_LOGS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getLog: state => state.log,
    getLogs: state => state.logs,
    getLoadingLog: state => state.loadingLog,
    getShowModalNewLog: state => state.show_modal_new_log
}

export default {
    state,
    getters,
    mutations,
    actions
};